module.exports = __webpack_public_path__ + "img/logo_go.7ec3732c.png";